import { render, staticRenderFns } from "./EditBarView.vue?vue&type=template&id=37caa969&scoped=true&"
import script from "./EditBarView.vue?vue&type=script&lang=js&"
export * from "./EditBarView.vue?vue&type=script&lang=js&"
import style0 from "./EditBarView.vue?vue&type=style&index=0&id=37caa969&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37caa969",
  null
  
)

export default component.exports